import { httpRequest } from "@services/http";
import type { NetworkTemplate } from "@models/networkTemplate.model";

export class CommandGetNetworkTemplateDetail {
  async run(templateId: number): Promise<NetworkTemplate> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content_network/network_templates/${templateId}/`;
    return await httpRequest<NetworkTemplate>(url, { method: "GET" });
  }
}
